export default __webpack_public_path__ + "static/media/hero.34e6cd07.jpg";